/* D&M · colección editorial v2.1 (20oct, videos livianos): vista 1/2/3/4, entradas, piezas con video, video al pasar el mouse y deriva de fotos al hacer scroll. */
(function () {
	if (window.__dmCol) return;
	window.__dmCol = true;

	var mqMobile = window.matchMedia('(max-width: 767px)');
	var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
	var mqHover = window.matchMedia('(hover: hover) and (pointer: fine)');
	var hasIO = 'IntersectionObserver' in window;

	/* Peso del video: Shopify entrega 1080p en Liquid; usamos la versión de 720p o 480p del mismo archivo */
	var conn = navigator.connection || {};
	var lowData = !!conn.saveData || /(^|-)2g|3g/.test(conn.effectiveType || '');
	var RENDITIONS = {
		'HD-1080p-7.2Mbps': ['HD-720p-4.5Mbps', 'SD-480p-1.5Mbps'],
		'HD-1080p-4.8Mbps': ['HD-720p-3.0Mbps', 'SD-480p-1.2Mbps'],
		'HD-1080p-3.3Mbps': ['HD-720p-2.1Mbps', 'SD-480p-1.0Mbps']
	};
	function rendition(url, small) {
		if (!url) return url;
		for (var k in RENDITIONS) { if (url.indexOf(k) > -1) return url.replace(k, RENDITIONS[k][small ? 1 : 0]); }
		return url;
	}
	function setSrc(v, url) {
		var full = url;
		v.addEventListener('error', function onErr() { v.removeEventListener('error', onErr); if (v.getAttribute('src') !== full) { v.setAttribute('src', full); v.load(); } });
		v.setAttribute('src', v.__dmSrc || url);
	}
	function featSrc(v) {
		var u = v.dataset.src; if (!u) return null;
		v.__dmSrc = rendition(u, mqMobile.matches || lowData);
		return u;
	}
	var pageReady = document.readyState === 'complete';
	if (!pageReady) window.addEventListener('load', function () { setTimeout(function () { pageReady = true; document.querySelectorAll('[data-dm-feat]').forEach(function (box) { if (box.__dmVisible) playFeat(box); }); }, 600); });
	function playFeat(box) {
		var v = box.querySelector('.dm-feat__video');
		if (!v || box.__dmPaused || mqReduce.matches || !pageReady) return;
		if (!v.getAttribute('src')) { var u = featSrc(v); if (u) setSrc(v, u); }
		var p = v.play(); if (p && p.catch) p.catch(function () {});
	}

	/* Vista */
	function key() { return mqMobile.matches ? 'dm-cols-m' : 'dm-cols-d3'; }
	function cols() {
		var v = null;
		try { v = localStorage.getItem(key()); } catch (e) {}
		var ok = mqMobile.matches ? ['1', '2'] : ['2', '3', '4'];
		return ok.indexOf(v) > -1 ? v : (mqMobile.matches ? '2' : '3');
	}
	function applyView() {
		var c = cols(), g = document.getElementById('product-grid');
		if (g) { g.classList.remove('dm-cols-1', 'dm-cols-2', 'dm-cols-3', 'dm-cols-4'); g.classList.add('dm-cols-' + c); }
		document.querySelectorAll('[data-dm-view] .dm-view__btn').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-cols') === c ? 'true' : 'false'); });
	}
	document.addEventListener('click', function (e) {
		var b = e.target.closest && e.target.closest('[data-dm-view] .dm-view__btn');
		if (!b) return;
		try { localStorage.setItem(key(), b.getAttribute('data-cols')); } catch (err) {}
		applyView();
		requestAnimationFrame(drift);
	});

	/* Entradas escalonadas, una sola vez por elemento */
	var revealIO = hasIO ? new IntersectionObserver(function (entries) {
		var shown = entries.filter(function (en) { return en.isIntersecting; }).map(function (en) { return en.target; });
		shown.sort(function (a, b) { var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect(); return (ra.top - rb.top) || (ra.left - rb.left); });
		shown.forEach(function (el, i) {
			el.style.setProperty('--dl', Math.min(i, 5) * 80 + 'ms');
			el.classList.add('is-in');
			revealIO.unobserve(el);
		});
	}, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;

	/* Piezas con video: reproducen solo en pantalla, con pausa manual */
	var featIO = hasIO ? new IntersectionObserver(function (entries) {
		entries.forEach(function (en) {
			var box = en.target, v = box.querySelector('.dm-feat__video');
			if (!v) return;
			box.__dmVisible = en.isIntersecting;
			if (en.isIntersecting) playFeat(box);
			else if (!v.paused) v.pause();
		});
	}, { rootMargin: '10% 0px', threshold: 0.3 }) : null;

	document.addEventListener('click', function (e) {
		var t = e.target.closest && e.target.closest('.dm-feat__toggle');
		if (!t) return;
		e.preventDefault();
		var box = t.closest('[data-dm-feat]'), v = box && box.querySelector('.dm-feat__video');
		if (!v) return;
		var name = t.getAttribute('aria-label').replace(/^(Pausar|Reproducir) /, '');
		if (v.paused) {
			if (!v.getAttribute('src')) { var u = featSrc(v); if (u) setSrc(v, u); }
			box.__dmPaused = false; var p = v.play(); if (p && p.catch) p.catch(function () {});
			t.setAttribute('aria-pressed', 'false'); t.setAttribute('aria-label', 'Pausar ' + name);
		} else {
			box.__dmPaused = true; v.pause();
			t.setAttribute('aria-pressed', 'true'); t.setAttribute('aria-label', 'Reproducir ' + name);
		}
	});

	function syncToggles(root) {
		if (!mqReduce.matches && !lowData) return;
		root.querySelectorAll('[data-dm-feat]').forEach(function (box) {
			box.__dmPaused = true;
			var t = box.querySelector('.dm-feat__toggle');
			if (t && t.getAttribute('aria-pressed') !== 'true') {
				t.setAttribute('aria-pressed', 'true');
				t.setAttribute('aria-label', t.getAttribute('aria-label').replace(/^Pausar/, 'Reproducir'));
			}
		});
	}

	/* Video al pasar el mouse en las tarjetas con video */
	function hoverIn(li) {
		if (!mqHover.matches || mqReduce.matches || lowData) return;
		var link = li.querySelector('.product-card--featured-image-link');
		if (!link) return;
		var v = li.__dmV;
		if (!v) {
			v = document.createElement('video');
			v.className = 'dm-hv'; v.muted = true; v.loop = true; v.playsInline = true; v.preload = 'metadata';
			v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
			v.addEventListener('playing', function () { v.classList.add('is-ready'); });
			var u = li.getAttribute('data-dm-video');
			v.__dmSrc = rendition(u, true);
			setSrc(v, u);
			link.appendChild(v); li.__dmV = v;
		}
		li.classList.add('dm-hv-on');
		var p = v.play(); if (p && p.catch) p.catch(function () {});
	}
	function hoverOut(li) {
		clearTimeout(li.__dmT);
		li.classList.remove('dm-hv-on');
		if (li.__dmV) li.__dmV.pause();
	}
	document.addEventListener('pointerover', function (e) {
		var li = e.target.closest && e.target.closest('.dm-clean li[data-dm-video]');
		if (li && !li.contains(e.relatedTarget)) { clearTimeout(li.__dmT); li.__dmT = setTimeout(function () { hoverIn(li); }, 250); }
	});
	document.addEventListener('pointerout', function (e) {
		var li = e.target.closest && e.target.closest('.dm-clean li[data-dm-video]');
		if (li && !li.contains(e.relatedTarget)) hoverOut(li);
	});

	/* Deriva vertical de fotos grandes al hacer scroll (solo transform) */
	var drifters = [], ticking = false;
	function drift() {
		ticking = false;
		if (mqReduce.matches) return;
		var vh = window.innerHeight;
		for (var i = 0; i < drifters.length; i++) {
			var el = drifters[i], box = el.parentNode.getBoundingClientRect();
			if (box.bottom < -100 || box.top > vh + 100) continue;
			var k = ((box.top + box.height / 2) - vh / 2) / (vh / 2 + box.height / 2);
			k = Math.max(-1, Math.min(1, k));
			el.style.transform = 'translate3d(0,' + (k * -5).toFixed(2) + '%,0)';
		}
	}
	function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(drift); } }
	window.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('resize', onScroll, { passive: true });

	/* Inicialización por grilla (se repite cuando los filtros reemplazan la grilla o se cargan más productos) */
	function init() {
		var g = document.getElementById('product-grid');
		if (!g || !g.closest('.dm-clean')) return;
		if (!/dm-cols-/.test(g.className)) applyView();
		var anim = hasIO && document.documentElement.classList.contains('dm-js');
		var first = [];
		g.querySelectorAll(':scope > li').forEach(function (li) {
			if (li.__dmInit) return;
			li.__dmInit = true;
			if (anim) {
				var r = li.getBoundingClientRect();
				if (r.top < window.innerHeight && r.bottom > 0) first.push(li);
				else revealIO.observe(li);
			} else li.classList.add('is-in');
			li.querySelectorAll('[data-dm-feat]').forEach(function (box) {
				if (featIO) featIO.observe(box);
				else { box.__dmVisible = true; playFeat(box); }
			});
		});
		if (first.length) requestAnimationFrame(function () { requestAnimationFrame(function () {
			first.forEach(function (li, i) { li.style.setProperty('--dl', Math.min(i, 6) * 90 + 'ms'); li.classList.add('is-in'); });
		}); });
		syncToggles(g);
		drifters = Array.prototype.slice.call(document.querySelectorAll('.dm-clean [data-drift]'));
		onScroll();
	}

	var moTimer;
	new MutationObserver(function () { clearTimeout(moTimer); moTimer = setTimeout(init, 60); }).observe(document.documentElement, { childList: true, subtree: true });
	mqMobile.addEventListener('change', function () { applyView(); onScroll(); });
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();